module.exports = __webpack_public_path__ + "img/cafe-manduca.40b05d24.jpeg";